const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

/**
 * Fetch driving directions from Mapbox Directions API.
 * @param {{ lng: number, lat: number }} from - Start point
 * @param {{ lng: number, lat: number }} to - End point
 * @param {{ alternatives?: boolean, profile?: string }} options
 * @returns {Promise<{ routes: Array<{ distance: number, duration: number, geometry: object }> }>}
 */
export async function getDirections(from, to, options = {}) {
  const { alternatives = true, profile = 'driving' } = options;

  if (!MAPBOX_TOKEN) {
    throw new Error('VITE_MAPBOX_TOKEN is not configured');
  }

  const coordinates = `${from.lng},${from.lat};${to.lng},${to.lat}`;
  const params = new URLSearchParams({
    alternatives: String(alternatives),
    geometries: 'geojson',
    overview: 'full',
    steps: 'false',
    access_token: MAPBOX_TOKEN,
  });

  const url = `https://api.mapbox.com/directions/v5/mapbox/${profile}/${coordinates}?${params}`;
  const res = await fetch(url);

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 429) throw new Error('Rate limit exceeded. Please try again.');
    throw new Error(body.message || `Directions request failed (${res.status})`);
  }

  const data = await res.json();

  if (!data.routes?.length) {
    throw new Error('No route found between these points');
  }

  return {
    routes: data.routes.map((r) => ({
      distance: r.distance,   // meters
      duration: r.duration,   // seconds
      geometry: r.geometry,    // GeoJSON LineString
    })),
  };
}

export function isMapboxConfigured() {
  return Boolean(MAPBOX_TOKEN);
}
